export class CategoryEmitterModel {
    constructor() {
        this.operator = false;
        this.activeProjects = false;
    }
    filteredList: string[] = [];
    groupBy: string;
    displayType: string;
    operator: boolean;
    activeProjects: boolean;
}
